import { useEffect } from "react";

export function AdapexAds({ adunit, ...props }: { adunit: string; className?: string }) {
  useEffect(() => {
    ((window as any).aaw = (window as any).aaw || { cmd: [] }).cmd.push(() => {
      (window as any).aaw.processAdsOnPage();
    });
  }, []);

  return (
    <div>
      {!(props.className && props.className.includes("quiz--single-page__bottom-ads")) ? (
        <div className="ad-label">ADVERTISEMENT</div>
      ) : null}
      <div data-aaad="true" data-aa-adunit={`/22181265/${adunit}`} {...props} />
    </div>
  );
}
